import { render } from "./EditCategory.vue?vue&type=template&id=25f8812f&scoped=true&ts=true"
import script from "./EditCategory.vue?vue&type=script&lang=ts"
export * from "./EditCategory.vue?vue&type=script&lang=ts"

import "./EditCategory.vue?vue&type=style&index=0&id=25f8812f&lang=scss&scoped=true"

import exportComponent from "D:\\YellowBeardProject\\dobby\\dobbyshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25f8812f"]])

export default __exports__